import * as firebase from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

export const firebaseConfig = {
  apiKey: "AIzaSyCxQGx_TO2lSZ1WX3UfP5WrH6ZXQbeDVLo",

  authDomain: "oakland-portal-4e070.firebaseapp.com",

  projectId: "oakland-portal-4e070",

  storageBucket: "oakland-portal-4e070.appspot.com",

  messagingSenderId: "124935199857",

  appId: "1:124935199857:web:90e21df1219a9d63f14fd0",

  measurementId: "G-NL4F32J0K8",
};
firebase.initializeApp(firebaseConfig);

let messaging = getMessaging();

export const gettoken = async () => {
  let currentToken = "";
  try {
    // currentToken;
    currentToken = await getToken(messaging, { vapidKey: messaging.vapidKey });
  } catch (error) {
    /* console.log("An error occurred while retrieving token. ", error); */
  }
  return currentToken;
};

export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });
